import VerticalTabButtonGroup from './VerticalTabButtonGroup';
import type { VerticalTabButtonGroupProps } from './VerticalTabButtonGroup';

export type { VerticalTabButtonGroupProps };
export default VerticalTabButtonGroup;
